/* eslint-disable array-callback-return */
import moment from 'moment';
import * as actionTypes from '../../../constants/actionTypes';
import config from '../../../util/config';

let initProfile = {
  vFirstname: '',
  vLastname: '',
  iDriverScore: 5,
  iOnlineStatus: 1,
  vFuelCarCode: '',
};
let initRequestOnline = {
  vRequestCode: '',
  vCustomerMobileNumber: '',
  iPaymentType: '',
  iStatus: '',
  iRequestStatus: '',
  vFuelInfoTitle: '',
  iVolumeRequested: 0,
  iVolumeReceived: 0,
  location: {
    dLatitude: config.latitude,
    dLongitude: config.longitude,
    vAddress: '',
  },
  operatorLocation: { dLatitude: config.latitude, dLongitude: config.longitude },
  licensePlate: [
    {
      eCarType: '',
      vNameCar: '',
      LicensePlate: {},
    },
  ],
  price: { iTotalPrice: 0 },
};

let initOperatorLocation = {
  dLatitude: config.latitude,
  dLongitude: config.longitude,
};

const initState = {
  mobile: '',
  password: '',
  kilometer: '',
  repeatPassword: '',
  supportNumber: '',
  profile: initProfile,
  requestOnline: initRequestOnline,
  operatorLocation: initOperatorLocation,
  endTime: moment().format('YYYY-MM-DD') + ' 00:00',
  startTime: moment().format('YYYY-MM-DD') + ' 00:00',
  list: [],
  amount: 0,
  fuelCarCode: '',
  litrage: '',
  details: null,
  comment: '',
  reasonSupport: [],
};

const fieldsReducer = (state = initState, action) => {
  switch (action.type) {
    case actionTypes.SET_FIELDS:
      let newState = { ...state };
      action.payload.map((payload) => {
        let data = payload.data;
        let field = payload.field;
        if (field === 'mobile') newState.mobile = data;
        else if (field === 'list') newState.list = data;
        else if (field === 'amount') newState.amount = data;
        else if (field === 'comment') newState.comment = data;
        else if (field === 'details') newState.details = data;
        else if (field === 'litrage') newState.litrage = data;
        else if (field === 'profile') newState.profile = data;
        else if (field === 'endTime') newState.endTime = data;
        else if (field === 'kilometer') newState.kilometer = data;
        else if (field === 'password') newState.password = data;
        else if (field === 'startTime') newState.startTime = data;
        else if (field === 'fuelCarCode') newState.fuelCarCode = data;
        else if (field === 'supportNumber') newState.supportNumber = data;
        else if (field === 'requestOnline') newState.requestOnline = data;
        else if (field === 'empty_profile') newState.profile = initProfile;
        else if (field === 'repeatPassword') newState.repeatPassword = data;
        else if (field === 'operatorLocation') newState.operatorLocation = data;
        else if (field === 'reasonSupport') newState.reasonSupport = data;
        else if (field === 'empty_requestOnline') {
          newState.requestOnline = initRequestOnline;
          newState.operatorLocation = initOperatorLocation;
        }
      });
      return newState;
    case actionTypes.EMPTY_FIELDS:
      return {
        ...state,
        mobile: '',
        password: '',
      };
    default:
      return state;
  }
};

export default fieldsReducer;
